<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc1"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/introduction">Introduction: How I Got Started/Once an Industrial Epicenter</a></p>
<p class="toc2"><span href="#/chapter1" title="Link target outside of Sample">1. The Catlin House: Did the Catlins Ever Leave?</span></p>
<p class="toc1"><span href="#/chapter2" title="Link target outside of Sample">2. The Lackawanna Station Hotel: Terror on the Sixth Floor</span></p>
<p class="toc1"><span href="#/chapter3" title="Link target outside of Sample">3. Courthouse Square: The Lady in White and Other Macabre Tales</span></p>
<p class="toc1"><span href="#/chapter4" title="Link target outside of Sample">4. The Hotel Jermyn: Leave the Ghost Light On for Eleanor</span></p>
<p class="toc1"><span href="#/chapter5" title="Link target outside of Sample">5. The Banshee Pub: Beware of the Basement</span></p>
<p class="toc1"><span href="#/chapter6" title="Link target outside of Sample">6. Andy Gavin’s Eatery and Pub: A Ghost Named George</span></p>
<p class="toc1"><span href="#/chapter7" title="Link target outside of Sample">7. The Scranton Cultural Center at the Masonic Temple: Masonic Ghosts</span></p>
<p class="toc1"><span href="#/chapter8" title="Link target outside of Sample">8. The Colonnade: Boys Will Be Boys, Even After Death</span></p>
<p class="toc1"><span href="#/chapter9" title="Link target outside of Sample">9. The Electric City Trolley Museum: Haunted Car #46</span></p>
<p class="toc2"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?041bba5c